export const ResourceUrls = {
  fireflyDiscordInvite: 'https://discord.gg/xZ7qqy97MZ',
  fireflyFFI:
    'https://hyperledger.github.io/firefly/reference/firefly_interface_format',
  fireflySDK: 'https://github.com/hyperledger/firefly-sdk-nodejs',
  fireflyTutorial: 'https://hyperledger.github.io/firefly/tutorials',
  fireflyTutorialExampleSC:
    'https://hyperledger.github.io/firefly/tutorials/custom_contracts/ethereum.html#example-smart-contract',
  fireflyTutorialEvents:
    'https://hyperledger.github.io/firefly/tutorials/events.html',
  fireflyTutorialDeployContract:
    'https://hyperledger.github.io/firefly/tutorials/custom_contracts/ethereum.html#contract-deployment',
  fireflyTutorialDeployContractFabric:
    'https://hyperledger.github.io/firefly/tutorials/custom_contracts/fabric.html',
  sandBoxGH: 'https://github.com/hyperledger/firefly-sandbox',
  solidityABI:
    'https://docs.ethers.io/v5/api/utils/abi/formats/#abi-formats--solidity',
  solidityInstall:
    'https://docs.soliditylang.org/en/v0.8.13/installing-solidity.html',
};
